(function () {
  var observer;

  function inView(node) {
    var rect = node.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight;
    return rect.width > 0 && rect.height > 0 && rect.bottom > 80 && rect.top < height * 0.72;
  }

  function mark(node) {
    node.classList.add('is-in');
    if (observer) observer.unobserve(node);
  }

  function reveal(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('.myo-rise:not(.is-in)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    nodes.forEach(function (node) {
      if (reduce || inView(node)) mark(node);
    });

    if (!reduce && 'IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) mark(entry.target);
          });
        }, { threshold: 0.35, rootMargin: '0px 0px -22% 0px' });
      }
      nodes.forEach(function (node) {
        if (!node.classList.contains('is-in')) observer.observe(node);
      });
    }

    document.documentElement.classList.add('myo-rise-armed');
  }

  function boot() {
    reveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('load', boot);
  document.addEventListener('scroll', boot, true);
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });
})();
